var map = {
	"./amit-shah-roadshow-ahmedabad.png": 233,
	"./audio-engineer.png": 59,
	"./dj-viola-international.png": 350,
	"./engineers-practice-workshops.jpg": 810,
	"./garba-shows-live-sound.png": 50,
	"./gujarat-vandebharat-train-opening.png": 812,
	"./gujarati-singer-1.png": 643,
	"./gujarati-singer.png": 849,
	"./international-dj-sound-reinforcement.png": 374,
	"./ishani-dave-artist.png": 880,
	"./live-event-performance-1.png": 949,
	"./live-event-performance-2.png": 198,
	"./live-event-performance-3.png": 535,
	"./live-event-performance-4.png": 368,
	"./live-sound-reinforcement.png": 667,
	"./logo.jpg": 178,
	"./malhar-thakar-gujarati-artist.png": 514,
	"./sound-lights-led-production-new-year.png": 663,
	"./sound-lights-trussing-1.png": 515,
	"./sound-lights-trussing-2.png": 651,
	"./sound-trussing.png": 526,
	"./sufi-gazal-night.png": 11
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;